import React from 'react';
import { Center, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as InfoSvg } from 'resources/images/info.svg';

export const NotSupportedError = () => {
  return (
    <Center height="100%" data-testid="unsupported-lyrics-message">
      <Flex direction="column" alignItems="center" maxWidth={600} py={2}>
        <InfoSvg width={96} height={96} />
        <Text
          fontWeight={600}
          lineHeight="small"
          fontSize="xl"
          textAlign="center"
          py={2}
        >
          Time to upgrade!
        </Text>
        <Text
          fontWeight={400}
          fontSize="md"
          color="textSubdued"
          textAlign="center"
        >
          We have released the new Lyrics experience which your current version
          does not support. You need to update to the latest version of the app
          to continue to use lyrics.
        </Text>
      </Flex>
    </Center>
  );
};
